import React from 'react';
import { Body5, Container } from '@ui';
import { isSetupActive, SETUP_ACTIVE_STATUSES } from '@services/fmdc';
import { FmdcTenantContext } from './FmdcTenantContext';
import { TenantCard } from './TenantCard';
import { SetupForm } from './SetupForm';
import { SettingsForm } from './SettingsForm';

// Settings: the tenant card for everyone; for admins, the setup form (first setup or an upgrade)
// and, once the client exists, the settings form. Members read the card and nothing else.
//
// Before the first setup the page itself routes an admin here whatever the URL, so this view is
// also the whole of the not-set-up gate for an admin.

export const SettingsView = () => {
  const { tenant, canAdmin, pendingSetup, reload, setPendingSetup } = React.useContext(FmdcTenantContext);

  const setup = tenant?.setup || pendingSetup;
  // A stale setup is one the server has given up on: not blocking, and the form says so.
  const isStale = !!setup?.stale && SETUP_ACTIVE_STATUSES.includes(setup.status);
  const isActive = isSetupActive(setup);

  const handleQueued = (queuedSetup) => {
    if (queuedSetup) setPendingSetup(queuedSetup);
    reload();
  };

  const showCard = !!tenant || !!setup;

  return (
    <div>
      {showCard ? (
        <TenantCard tenant={tenant} canAdmin={canAdmin} pendingSetup={pendingSetup} />
      ) : (
        !canAdmin && <Body5 isLowContrast>Data capture has not been set up for this account.</Body5>
      )}

      {canAdmin && (
        <Container top={showCard ? 24 : 0}>
          <SetupForm
            hasTemplate={!!tenant?.template_version}
            blockedReason={isActive ? 'A setup is already running.' : null}
            isStale={isStale}
            onQueued={handleQueued}
          />
        </Container>
      )}

      {canAdmin && tenant && (
        <Container top={24}>
          <SettingsForm tenant={tenant} onSaved={() => reload()} />
        </Container>
      )}
    </div>
  );
};
